<template>
  <div class="balloon-container" :class="backgroundColor">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'CustomBalloon',
  meta: {
    description: 'Componente común Balloon contenedor.',
  },
  props: {
    text: {
      type: String,
      required: true,
      default: '',
      meta: {
        description: 'Texto del Ballon',
        example: 'some title',
      },
    },
    backgroundColor: {
      type: String,
      default: '',
      meta: {
        description:
          'Color de fondo del Ballon, Enumeración en import { Colors } from "@/components/common"',
        example: 'Colors.GREEN',
      },
    },
  },
};
</script>

<style scoped>
.balloon-container {
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px;
  background-color: #f4f6f3;
  text-align: center;
  color: #11291b;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 900;
}
.balloon-container.green {
  background-color: #a4e5b2;
}
.balloon-container.brown {
  background-color: #d5b899;
}
.balloon-container.yellow {
  background-color: #f8ea80;
}
.balloon-container.pink {
  background-color: #fcc9c8;
}
.balloon-container.violet {
  background-color: #ddb3d7;
}
.balloon-container.chardonnay {
  background-color: #ffc18d;
}
.balloon-container.gray {
  background-color: #b5c3bc;
  color: white;
}
</style>
